/**
 * @hidden
 */
export var FOCUS_ACTION;

(function (FOCUS_ACTION) {
  FOCUS_ACTION["next"] = "next";
  FOCUS_ACTION["prev"] = "prev";
  FOCUS_ACTION["current"] = "current";
  FOCUS_ACTION["reset"] = "reset";
})(FOCUS_ACTION || (FOCUS_ACTION = {}));
/**
 * @hidden
 */


export var focusReducer = function focusReducer(state, action) {
  var currentIndex = action.items.findIndex(function (i) {
    return i === state;
  });

  switch (action.type) {
    case FOCUS_ACTION.next:
      return currentIndex === action.items.length - 1 ? state : action.items[currentIndex + 1];

    case FOCUS_ACTION.prev:
      return currentIndex === 0 ? state : action.items[currentIndex - 1];

    case FOCUS_ACTION.current:
      return action.payload;

    case FOCUS_ACTION.reset:
      return null;

    default:
      return state;
  }
};